import { useAxios } from "@hooks";
import { useQuery } from "@tanstack/react-query";
import { AssessorAssignment } from "../../types/grading/PendingCorrection";

/**
 * Gets assessor assignments for an exam term and/or a specific exam instance.
 */
export const useGetAssignments = (
  params: { examTermId?: string | null; examInstanceId?: string | null },
  options?: { enabled?: boolean }
) => {
  const axios = useAxios();
  const { examTermId, examInstanceId } = params;

  return useQuery<AssessorAssignment[]>({
    queryKey: ["gradingAssignments", examTermId ?? null, examInstanceId ?? null],
    queryFn: async () => {
      const query = new URLSearchParams();
      if (examTermId) query.append("examTermId", examTermId);
      if (examInstanceId) query.append("examInstanceId", examInstanceId);
      const response = await axios.get<AssessorAssignment[]>(
        `/api/grading/assignments?${query.toString()}`
      );
      return response.data;
    },
    enabled: (!!examTermId || !!examInstanceId) && options?.enabled !== false,
  });
};

export default useGetAssignments;
